// Phones: a table wider than the screen becomes a stack of cards (one card per row, each value
// labelled with its column name — see `table.m-cards` in index.css). Works for every table in the
// app, present and future, so a new tab needs no per-table phone code. Tables that already fit
// stay tables. Opt out with className="no-m-cards"; pages that render their own phone cards
// (`hidden md:table`) are never touched because a hidden table has no width.
const PHONE = "(max-width: 639px)";

function headerLabels(table) {
    const rows = table.tHead?.rows;
    if (!rows?.length) return null;
    const labels = [];
    for (const th of rows[rows.length - 1].cells) {
        const text = (th.innerText || th.textContent || "").replace(/\s+/g, " ").trim();
        for (let i = 0; i < (th.colSpan || 1); i++) labels.push(text);
    }
    return labels;
}

function scrollBox(table) {
    let p = table.parentElement;
    while (p && p !== document.body) {
        if (/(auto|scroll|hidden)/.test(getComputedStyle(p).overflowX)) return p;
        p = p.parentElement;
    }
    return table.parentElement;
}

function label(table) {
    const labels = headerLabels(table);
    if (!labels) return;
    const key = labels.join("|");
    const fresh = table.dataset.mLabels !== key;
    table.dataset.mLabels = key;
    for (const body of table.tBodies) {
        for (const tr of body.rows) {
            if (!fresh && tr.dataset.ml === "1") continue;
            let i = 0;
            for (const td of tr.cells) {
                // A cell that spans the whole row (a "nothing here" line, an expanded detail) has no label.
                td.dataset.label = td.colSpan > 1 ? "" : labels[i] || "";
                i += td.colSpan || 1;
            }
            tr.dataset.ml = "1";
        }
    }
}

function scan() {
    const phone = window.matchMedia(PHONE).matches;
    for (const table of document.querySelectorAll("table")) {
        if (table.classList.contains("no-m-cards")) continue;
        if (!phone) {
            table.classList.remove("m-cards");
            continue;
        }
        if (!table.classList.contains("m-cards")) {
            if (!table.offsetWidth) continue; // hidden (the page has its own phone layout)
            const box = scrollBox(table);
            if (table.scrollWidth <= (box?.clientWidth || window.innerWidth) + 4) continue;
            table.classList.add("m-cards");
        }
        label(table);
    }
}

export function startMobileTables() {
    let queued = false;
    const later = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
            queued = false;
            scan();
        });
    };
    new MutationObserver(later).observe(document.body, { childList: true, subtree: true, characterData: true });
    window.matchMedia(PHONE).addEventListener?.("change", later);
    window.addEventListener("resize", later);
    later();
}
